import axios from 'axios';
import { generateUUID } from '../../Utils';
import { getToken } from '../../Utils/token';

const configuration = {
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': [
      'Origin', 'Accept', 'X-Requested-With', 'Content-Type', 'Authorization'
    ],
    'Idempotency-Key': generateUUID()
  }
};

const instance = axios.create({ configuration });

instance.interceptors.request.use((config) => {
  if (config.skipAuth) return config;

  const token = getToken() || null;

  let newHeaders = config.headers;
  if (token) {
    newHeaders = Object.assign({}, newHeaders, { Authorization: `Bearer ${token}` });
  }
  return Object.assign({}, config, { headers: newHeaders });
}, (error) => Promise.reject(error));


const getAxios = () => instance;

export default getAxios;